import * as yup from "yup";

import {
  ELEMENT_LINK_DESTINATION,
  ELEMENT_METHOD,
  ELEMENT_POSITIONING,
  ELEMENT_SCOPE,
  ELEMENT_SHAPE,
  ELEMENT_SIZE,
  ELEMENT_STATUS,
  ELEMENT_TYPE,
} from "../../constants";
import { MESSAGES } from "../messages";

export const elementValidations = {
  elementId: yup
    .number()
    .required(MESSAGES.ELEMENT_ID_REQUIRED)
    .integer(MESSAGES.ELEMENT_ID_INVALID)
    .typeError(MESSAGES.ELEMENT_ID_INVALID),
  experienceId: yup
    .number()
    .optional()
    .nullable()
    .integer(MESSAGES.ELEMENT_EXPERIENCE_ID_INVALID)
    .typeError(MESSAGES.ELEMENT_EXPERIENCE_ID_INVALID),
  mediaItemId: yup
    .number()
    .optional()
    .nullable()
    .integer(MESSAGES.ELEMENT_MEDIA_ITEM_ID_INVALID)
    .typeError(MESSAGES.ELEMENT_MEDIA_ITEM_ID_INVALID),
  type: yup
    .string()
    .required(MESSAGES.ELEMENT_TYPE_REQUIRED)
    .oneOf(
      [ELEMENT_TYPE.CONTENT, ELEMENT_TYPE.LINK, ELEMENT_TYPE.MAP, ELEMENT_TYPE.VOICE_MEMO],
      MESSAGES.ELEMENT_TYPE_INVALID,
    ),
  title: yup
    .string()
    .required(MESSAGES.ELEMENT_TITLE_REQUIRED)
    .typeError(MESSAGES.ELEMENT_TITLE_INVALID)
    .test("pattern", "Invalid", (value) => /^[a-zA-Z\d\W ,.'-_]+$/u.test(value))
    .test("maxCharacter", (value, { path, createError }) => {
      return value && value.length > 50
        ? createError({
            message: `Character limit of ${value.length - 50}/50 exceeded`,
            path,
          })
        : true;
    }),
  url: yup.string().required(MESSAGES.ELEMENT_URL_REQUIRED).typeError(MESSAGES.ELEMENT_URL_INVALID),
  status: yup
    .string()
    .required(MESSAGES.ELEMENT_STATUS_REQUIRED)
    .oneOf([ELEMENT_STATUS.CREATED, ELEMENT_STATUS.DRAFT], MESSAGES.ELEMENT_STATUS_INVALID),
  linkDestination: yup
    .string()
    .required(MESSAGES.ELEMENT_LINK_DESTINATION_REQUIRED)
    .oneOf(
      [ELEMENT_LINK_DESTINATION.MODAL, ELEMENT_LINK_DESTINATION.NEW_TAB],
      MESSAGES.ELEMENT_LINK_DESTINATION_INVALID,
    ),
  size: yup
    .string()
    .required(MESSAGES.ELEMENT_SIZE_REQUIRED)
    .oneOf([ELEMENT_SIZE.LARGE, ELEMENT_SIZE.MEDIUM, ELEMENT_SIZE.SMALL], MESSAGES.ELEMENT_SIZE_INVALID),
  shape: yup
    .string()
    .required(MESSAGES.ELEMENT_SHAPE_REQUIRED)
    .oneOf([ELEMENT_SHAPE.CIRCLE, ELEMENT_SHAPE.SQUARE], MESSAGES.ELEMENT_SHAPE_INVALID),
  positioning: yup
    .string()
    .required(MESSAGES.ELEMENT_POSITIONING_REQUIRED)
    .oneOf([ELEMENT_POSITIONING.CONTENT, ELEMENT_POSITIONING.EXPERIENCE], MESSAGES.ELEMENT_POSITIONING_INVALID),
  scope: yup
    .string()
    .required(MESSAGES.ELEMENT_SCOPE_REQUIRED)
    .oneOf([ELEMENT_SCOPE.CONTENT, ELEMENT_SCOPE.EXPERIENCE], MESSAGES.ELEMENT_SCOPE_INVALID),
  showText: yup.boolean().required(MESSAGES.ELEMENT_SHOW_TEXT_REQUIRED).typeError(MESSAGES.ELEMENT_SHOW_TEXT_INVALID),
  color: yup.string().required(MESSAGES.ELEMENT_COLOR_REQUIRED).typeError(MESSAGES.ELEMENT_COLOR_INVALID),
  textColor: yup.string().required(MESSAGES.ELEMENT_TEXT_COLOR_REQUIRED).typeError(MESSAGES.ELEMENT_TEXT_COLOR_INVALID),
  iconName: yup.string().required(MESSAGES.ELEMENT_ICON_NAME_REQUIRED).typeError(MESSAGES.ELEMENT_ICON_NAME_INVALID),
  iconLink: yup.string().required(MESSAGES.ELEMENT_ICON_LINK_REQUIRED).typeError(MESSAGES.ELEMENT_ICON_LINK_INVALID),
  xFrameOptions: yup.string().optional().nullable().typeError(MESSAGES.ELEMENT_X_FRAME_OPTIONS_INVALID),
  helperText: yup.string().optional().typeError(MESSAGES.ELEMENT_HELPER_TEXT_INVALID),
  memoMethod: yup
    .string()
    .required(MESSAGES.ELEMENT_METHOD_REQUIRED)
    .oneOf(
      [ELEMENT_METHOD.UPLOAD, ELEMENT_METHOD.RECORD, ELEMENT_METHOD.FROM_LIBRARY],
      MESSAGES.ELEMENT_METHOD_INVALID,
    ),
  fileName: yup.string().optional().nullable().typeError(MESSAGES.ELEMENT_FILE_NAME_INVALID),
  fileSize: yup.number().optional().nullable().typeError(MESSAGES.ELEMENT_FILE_SIZE_INVALID),
  linkedId: yup.number().optional().nullable().typeError(MESSAGES.ELEMENT_LINKED_ID_INVALID),
  isEmbeddable: yup.boolean().optional().nullable().typeError(MESSAGES.ELEMENT_LINKED_ID_INVALID),
};
